// component
import Iconify from '../../components/Iconify';
import { useSelector } from "react-redux";
import { useParams } from 'react-router-dom';

// ----------------------------------------------------------------------

const getIcon = (name) => <Iconify icon={name} width={22} height={22} />;


export default function NavConfig() {
  const params = useParams();

  const adminSelectedAppNavConfig = (params) => {
    return [{
      'title': 'General',
      'menu': [
        {
          title: 'users',
          path: '/users',
          icon: getIcon('mdi:users-group'),
        },
        {
          title: 'my apps',
          path: '/apps',
          icon: getIcon('majesticons:iphone-x-apps'),
        }]
    },
    {
      'title': 'App', 'menu': [
        {
          title: 'reviews',
          path: '/apps/' + params.app_id + '/reviews',
          icon: getIcon('uil:comments'),
        },
        {
          title: 'info',
          path: '/apps/' + params.app_id + '/info',
          icon: getIcon('material-symbols:info-outline'),
        },
        {
          title: 'revenue',
          path: '/apps/' + params.app_id + '/revenue',
          icon: getIcon('mdi:money'),
        }
      ]
    },
    {
      'title': 'Profile', 'menu': [
        {
          title: 'General',
          path: '/profile',
          icon: getIcon('material-symbols:person')
        },
        {
          title: 'Subscription',
          path: '/subscription',
          icon: getIcon('material-symbols:priority')
        }
      ]
    }
    ]
  };


  const userSelectedAppNavConfig = (params) => {
    return [{
      'title': 'General',
      'menu': [
        {
          title: 'my apps',
          path: '/apps',
          icon: getIcon('majesticons:iphone-x-apps'),
        }]
    },
    {
      'title': 'App', 'menu': [
        {
          title: 'reviews',
          path: '/apps/' + params.app_id + '/reviews',
          icon: getIcon('uil:comments'),
        },
        {
          title: 'info',
          path: '/apps/' + params.app_id + '/info',
          icon: getIcon('material-symbols:info-outline'),
        },
        {
          title: 'revenue',
          path: '/apps/' + params.app_id + '/revenue',
          icon: getIcon('mdi:money'),
        }
      ]
    },
    {
      'title': 'Profile', 'menu': [
        {
          title: 'General',
          path: '/profile',
          icon: getIcon('material-symbols:person')
        },
        {
          title: 'Subscription',
          path: '/subscription',
          icon: getIcon('material-symbols:priority')
        }
      ]
    }
    ]
  };


  const adminSelectedUserNavConfig = (params) => {
    return [{
      'title': 'General',
      'menu': [
        {
          title: 'users',
          path: '/users',
          icon: getIcon('mdi:users-group'),
        },
        {
          title: 'my apps',
          path: '/apps',
          icon: getIcon('majesticons:iphone-x-apps'),
        }]
    },
    {
      'title': 'User', 'menu': [
        {
          title: 'dashboard',
          path: '/users/' + params.user_id,
          icon: getIcon('material-symbols:space-dashboard-sharp'),
        },
        {
          title: 'apps',
          path: '/users/' + params.user_id + '/apps',
          icon: getIcon('majesticons:iphone-x-apps'),
        },
        {
          title: 'actions',
          path: '/users/' + params.user_id + '/actions',
          icon: getIcon('mdi:call-to-action'),
        },
        {
          title: 'sent messages',
          path: '/users/' + params.user_id + '/sent',
          icon: getIcon('jam:messages-f'),
        },
        {
          title: 'subscriptions',
          path: '/users/' + params.user_id + '/subscription',
          icon: getIcon('ri:money-dollar-box-fill'),
        },
        {
          title: 'send message',
          path: '/users/' + params.user_id + '/messages',
          icon: getIcon('icon-park-solid:messages'),
        }
      ]
    },
    {
      'title': 'Profile', 'menu': [
        {
          title: 'General',
          path: '/profile',
          icon: getIcon('material-symbols:person')
        },
        {
          title: 'Subscription',
          path: '/subscription',
          icon: getIcon('material-symbols:priority')
        }
      ]
    }
    ]
  };

  const adminNavConfig = (params) => {
    return [{
      'title': 'General',
      'menu': [
        {
          title: 'users',
          path: '/users',
          icon: getIcon('mdi:users-group'),
        },
        {
          title: 'my apps',
          path: '/apps',
          icon: getIcon('majesticons:iphone-x-apps'),
        }]
    },
    {
      'title': 'Profile', 'menu': [
        {
          title: 'General',
          path: '/profile',
          icon: getIcon('material-symbols:person')
        },
        {
          title: 'Subscription',
          path: '/subscription',
          icon: getIcon('material-symbols:priority')
        }
      ]
    }
    ]
  };

  const userNavConfig = (params) => {
    return [{
      'title': 'General',
      'menu': [
        {
          title: 'my apps',
          path: '/apps',
          icon: getIcon('majesticons:iphone-x-apps'),
        }]
    },
    {
      'title': 'Profile', 'menu': [
        {
          title: 'General',
          path: '/profile',
          icon: getIcon('material-symbols:person')
        },
        {
          title: 'Subscription',
          path: '/subscription',
          icon: getIcon('material-symbols:priority')
        }
      ]
    }

    ]
  };

  const { type } = useSelector((state) => state.menus);
  const { user: account } = useSelector((state) => state.auth);
  // return adminSelectedAppNavConfig;
  if (account && account.role === 'admin') {
    if (type === "APP") {
      return adminSelectedAppNavConfig(params);
    }
    else if (type === 'USER') {
      return adminSelectedUserNavConfig(params);
    }
    else if (type === '') {
      return adminNavConfig(params);
    }
  } else if (account) {
    if (type === "APP") {
      return userSelectedAppNavConfig(params);
    }
    else if (type === 'PROFILE') {
      return userNavConfig(params);
    }
  }


  return userNavConfig(params);


}
